import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 汗汗漫画 | 免费韩国漫画在线阅读';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '了解汗汗漫画——免费韩国漫画在线阅读平台。品牌介绍、发展历程、用户口碑、联系方式。汇集海量韩漫大全，无需付费即可畅享正版韩漫资源。');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'http://sinotruckcn.com/about');
    }

    const orgSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '汗汗漫画',
      url: 'http://sinotruckcn.com/',
      description: '汗汗漫画提供免费韩国漫画在线阅读服务，汇集海量韩漫大全，涵盖热门题材。',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'hello@sinotruckcn.com',
      },
    };

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '汗汗漫画是免费的吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，汗汗漫画上的所有韩国漫画都是完全免费的，无需付费即可畅享正版韩漫资源。我们致力于为漫画爱好者提供优质的免费阅读体验。',
          },
        },
        {
          '@type': 'Question',
          name: '汗汗漫画的更新频率是怎样的？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '汗汗漫画每日更新，我们会及时同步最新的韩国漫画章节，确保读者能够在第一时间阅读到最新内容。追更不等待！',
          },
        },
        {
          '@type': 'Question',
          name: '如何在汗汗漫画上查找想看的漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以通过首页的分类导航按照题材（恋爱、悬疑、奇幻、动作等）浏览漫画，也可以使用搜索功能直接查找您想看的漫画作品。',
          },
        },
        {
          '@type': 'Question',
          name: '汗汗漫画支持手机阅读吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '支持！汗汗漫画采用响应式设计，完美适配手机、平板和电脑等各类设备，让您随时随地畅享漫画阅读体验。',
          },
        },
      ],
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.textContent = JSON.stringify(orgSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script2);

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'http://sinotruckcn.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '关于我们',
          item: 'http://sinotruckcn.com/about',
        },
      ],
    };
    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script3);

    return () => {
      if (document.head.contains(script1)) document.head.removeChild(script1);
      if (document.head.contains(script2)) document.head.removeChild(script2);
      if (document.head.contains(script3)) document.head.removeChild(script3);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <nav className="w-full px-6 md:px-10 py-4 bg-background-50 border-b border-background-200" aria-label="面包屑导航">
          <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm">
            <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200">首页</Link>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            </div>
            <span className="text-foreground-900 font-medium">关于我们</span>
          </div>
        </nav>

        <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 rounded-2xl bg-primary-100 text-primary-500">
                <i className="ri-book-read-line text-3xl"></i>
              </div>
              <h1 className="text-3xl md:text-5xl font-black font-heading text-foreground-950 mb-4">
                关于汗汗漫画
              </h1>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                让每一部好漫画，被更多人看见
              </p>
            </div>

            <article className="prose-custom max-w-3xl mx-auto">
              <div className="mb-16">
                <h2 className="text-2xl font-bold font-heading text-foreground-950 mb-6 flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-building-4-line text-primary-500"></i>
                  </div>
                  品牌故事
                </h2>
                <div className="space-y-4 text-base text-foreground-700 leading-relaxed">
                  <p>
                    汗汗漫画诞生于<strong>2020年</strong>，由一群热爱韩国漫画的年轻人共同创立。我们深知漫迷们对优质漫画内容的渴望，
                    也理解付费阅读给许多读者带来的困扰。因此，我们决定打造一个<strong>完全免费、内容海量、体验优质</strong>的韩国漫画阅读平台。
                  </p>
                  <p>
                    经过数年的发展，汗汗漫画已经成为国内领先的韩漫在线阅读平台之一，收录了超过<strong>2000部</strong>韩国漫画作品，
                    涵盖恋爱、悬疑、奇幻、动作、喜剧、恐怖等十几个热门题材分类，累计服务超过<strong>500万</strong>活跃读者。
                  </p>
                  <p>
                    我们的团队每天精心筛选和更新漫画内容，确保每一位读者都能在这里找到自己喜爱的作品。
                    从画质优化到阅读体验，从分类导航到搜索功能，我们不断打磨每一个细节，只为给漫迷们带来最好的阅读享受。
                  </p>
                </div>
              </div>

              <div className="mb-16">
                <h2 className="text-2xl font-bold font-heading text-foreground-950 mb-6 flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-shield-check-line text-primary-500"></i>
                  </div>
                  我们的承诺
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  <div className="bg-background-100 rounded-2xl p-6 text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-accent-100 text-accent-600">
                      <i className="ri-money-cny-circle-line text-2xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-foreground-900 mb-2">永久免费</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      所有漫画内容完全免费，不加任何付费墙，让每一位读者都能平等地享受漫画的乐趣
                    </p>
                  </div>
                  <div className="bg-background-100 rounded-2xl p-6 text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-100 text-primary-500">
                      <i className="ri-speed-up-line text-2xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-foreground-900 mb-2">极速更新</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      第一时间同步最新章节，每日更新不停歇，追更体验拉满
                    </p>
                  </div>
                  <div className="bg-background-100 rounded-2xl p-6 text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-secondary-200 text-secondary-700">
                      <i className="ri-shield-star-line text-2xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-foreground-900 mb-2">品质保障</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      高清画质、流畅加载、舒适排版，每一处细节都用心打磨
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-16">
                <h2 className="text-2xl font-bold font-heading text-foreground-950 mb-6 flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-user-heart-line text-primary-500"></i>
                  </div>
                  读者口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div className="bg-background-100 rounded-2xl p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {[1, 2, 3, 4, 5].map((s) => (
                        <div key={s} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-sm text-accent-500"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      &ldquo;从大一开始就在汗汗漫画上看韩漫了，画质超好，更新也快！最喜欢《她的心动瞬间》，每期必追！推荐给了身边所有朋友~&rdquo;
                    </p>
                    <p className="text-xs font-semibold text-foreground-900">—— 小雨同学，忠实读者 · 3年</p>
                  </div>
                  <div className="bg-background-100 rounded-2xl p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {[1, 2, 3, 4, 5].map((s) => (
                        <div key={s} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-sm text-accent-500"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      &ldquo;作为一个漫画测评博主，我几乎用过所有漫画平台。汗汗漫画的阅读体验是顶级的，加载快、排版舒适、画质清晰，强烈推荐！&rdquo;
                    </p>
                    <p className="text-xs font-semibold text-foreground-900">—— 像素猎人，漫画博主 · 50万粉丝</p>
                  </div>
                </div>
              </div>

              <div className="mb-16">
                <h2 className="text-2xl font-bold font-heading text-foreground-950 mb-6 flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-question-answer-line text-primary-500"></i>
                  </div>
                  常见问题
                </h2>
                <div className="space-y-4">
                  {[
                    { q: '汗汗漫画是免费的吗？', a: '是的，汗汗漫画上的所有韩国漫画都是完全免费的，无需付费即可畅享正版韩漫资源。我们致力于为漫画爱好者提供优质的免费阅读体验。' },
                    { q: '汗汗漫画的更新频率是怎样的？', a: '汗汗漫画每日更新，我们会及时同步最新的韩国漫画章节，确保读者能够在第一时间阅读到最新内容。追更不等待！' },
                    { q: '如何在汗汗漫画上查找想看的漫画？', a: '您可以通过首页的分类导航按照题材（恋爱、悬疑、奇幻、动作等）浏览漫画，也可以使用搜索功能直接查找您想看的漫画作品。' },
                    { q: '汗汗漫画支持手机阅读吗？', a: '支持！汗汗漫画采用响应式设计，完美适配手机、平板和电脑等各类设备，让您随时随地畅享漫画阅读体验。' },
                  ].map((faq) => (
                    <details key={faq.q} className="bg-background-100 rounded-xl overflow-hidden group">
                      <summary className="px-6 py-4 text-sm font-semibold text-foreground-900 cursor-pointer hover:text-primary-500 transition-colors duration-200 flex items-center justify-between">
                        {faq.q}
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2">
                          <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                        </div>
                      </summary>
                      <div className="px-6 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold font-heading text-foreground-950 mb-6 flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-send-line text-primary-500"></i>
                  </div>
                  联系我们
                </h2>
                <div className="bg-background-100 rounded-2xl p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                      <h3 className="text-lg font-bold text-foreground-900 mb-4">联系方式</h3>
                      <div className="space-y-3">
                        <div className="flex items-center gap-3">
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-mail-line text-primary-500"></i>
                          </div>
                          <span className="text-sm text-foreground-700">hello@sinotruckcn.com</span>
                        </div>
                        <div className="flex items-center gap-3">
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-wechat-line text-primary-500"></i>
                          </div>
                          <span className="text-sm text-foreground-700">微信公众号：汗汗漫画</span>
                        </div>
                        <div className="flex items-center gap-3">
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-weibo-line text-primary-500"></i>
                          </div>
                          <span className="text-sm text-foreground-700">微博：@汗汗漫画官方</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-foreground-900 mb-4">商务合作</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                        如果您有商务合作、版权合作或其他业务需求，欢迎通过以下方式联系我们。我们的团队将在24小时内回复。
                      </p>
                      <div className="flex items-center gap-3">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-briefcase-line text-primary-500"></i>
                        </div>
                        <span className="text-sm text-foreground-700">hello@sinotruckcn.com</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}